import { jsx as _jsx } from "react/jsx-runtime";
import { Spinner } from "../../ui/components/Spinner.js";
import { Container } from "../../ui/components/basic.js";
/**
 * @internal
 */
export function LoadingScreen(props) {
    return (_jsx(Container, { style: {
            minHeight: props.height || "350px",
        }, fullHeight: true, flex: "row", center: "both", children: _jsx(Spinner, { size: "xl", color: "secondaryText" }) }));
}
//# sourceMappingURL=LoadingScreen.js.map